import api from "shared/api";
import { OrganisationRaw } from "./models";
import { PrivatePersonRaw } from "./models/privatePerson";

const prefix = "api/relationprofile";

export const getOrganisationForCurrentUser = async (): Promise<
  OrganisationRaw
> => {
  try {
    const res = await api().get<OrganisationRaw>(`${prefix}/me/organisation`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getPrivatePersonForCurrentUser = async (): Promise<
  PrivatePersonRaw
> => {
  try {
    const res = await api().get<PrivatePersonRaw>(
      `${prefix}/me/private-person`
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};
